import { Record } from 'immutable'
import {
    SET_STAGE,
    CLEAR_BATTLE,
    SET_SELECTED_BET,
    SET_RESULT,
    SET_BATTLE_PLAYERS,
} from './constants'
import { stageType } from 'features/battle/constants/stageType'
import { resultType } from 'features/battle/constants/resultType'

const UpgradeRecord = Record({
    stage: stageType.betting,
    showWheel: false,
    result: resultType.win,
    selectedBet: 100,
    battlePlayers: [],
})

const defaultState = new UpgradeRecord()

const reducer = (state = new UpgradeRecord(), action) => {
    const { type, payload } = action

    switch (type) {
        case SET_STAGE:
            return state.set('stage', payload)

        case SET_SELECTED_BET:
            return state.set('selectedBet', payload)

        case SET_RESULT:
            return state.set('result', payload)

        case SET_BATTLE_PLAYERS:
            return state.set('battlePlayers', payload)

        case CLEAR_BATTLE:
            return defaultState

        default:
            return state
    }
}

export default reducer
